// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3cnDj","buttons":"PendingPaymentAlert_buttons__d2eDF"};